var emailRegex, highlightLinks, pathRegex, webRegex;

emailRegex = /\b[A-Z0-9\._%+\-]+@[A-Z0-9\.\-]+\.[A-Z]{2,4}\b/gi;

pathRegex = /(?:^|\s)(\.?\/(?:\\\s|[^\0 ])+)/gi;

webRegex = /\b(?:([a-z][\w\-]+:(?:\/{1,3}|[a-z0-9%.])|www\d{0,3}[.])(?:[^\s()<>]+|\([^\s()<>]+\))+(?:\([^\s()<>]+\)|[^`!()\[\]{};:'".,<>?«»“”‘’\s]))/gi;

highlightLinks = function(item) {
  var bodyString, linkIndex, linkTarget, linkText, match, results;
  bodyString = item.bodyString;
  if (bodyString.indexOf('@') !== -1) {
    while (match = emailRegex.exec(bodyString)) {
      linkIndex = match.index;
      linkText = bodyString.substring(linkIndex, linkIndex + match[0].length);
      if (bodyString[linkIndex - 1] !== ':') {
        item.addBodyHighlightAttributesInRange({
          link: 'mailto:' + linkText
        }, linkIndex, linkText.length);
      }
    }
  }
  if (bodyString.indexOf('/') !== -1) {
    while (match = pathRegex.exec(bodyString)) {
      linkIndex = match.index;
      linkText = match[1];
      linkIndex += match[0].length - match[1].length;
      item.addBodyHighlightAttributesInRange({
        link: 'path:' + linkText.replace(/\\ /g, ' ')
      }, linkIndex, linkText.length);
    }
  }
  results = [];
  while (match = webRegex.exec(bodyString)) {
    linkIndex = match.index;
    linkText = bodyString.substring(linkIndex, linkIndex + match[0].length);
    linkTarget = linkText;
    if (linkText.indexOf('www') === 0) {
      linkTarget = 'http://' + linkText;
    }
    results.push(item.addBodyHighlightAttributesInRange({
      link: linkTarget
    }, linkIndex, linkText.length));
  }
  return results;
};

module.exports = {
  highlightLinks: highlightLinks
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/serializations/taskpaper/smart-links.js
 ** module id = 199
 ** module chunks = 0
 **/